import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { MouseEventHandler, ReactChild, ReactNode } from "react";

import "./CustomInput.css";

type CustomInputProps = {
  children: ReactChild;
  label?: string;
  error?: string;
  id?: string;
  onClear?: MouseEventHandler<HTMLDivElement>;
  button?: ReactNode;
};

const CustomInput = ({
  children,
  label,
  id,
  error,
  onClear,
  button,
}: CustomInputProps) => {
  return (
    <div
      className={classNames("CustomInput", "CustomInput__container", {
        CustomInput__error: !!error,
      })}
    >
      {(label || error) && (
        <div className="inputLabel__container">
          {label ? <label htmlFor={id}>{label}</label> : undefined}
          {error && (
            <div className="error__container">
              <small>{error}</small>
              <FontAwesomeIcon icon="exclamation-circle" />
            </div>
          )}
        </div>
      )}
      <div className="CustomInput__wrapper">
        <div className="CustomInput__input">
          {children}
          {onClear && (
            <div onClick={onClear} className="CustomInput__input--clear">
              X
            </div>
          )}
        </div>
        {button}
      </div>
    </div>
  );
};

export default CustomInput;
